import api from "./api";

export const approvePayment = async (id: number) => {
  const response = await api.put(`/payments/${id}/approve`);
  return response.data;
};

export const rejectPayment = async (id: number) => {
  const response = await api.put(`/payments/${id}/reject`);
  return response.data;
};

export const getPayments = async (params: any) => {
  const { pagination, ...rest } = params || {};
  const response = await api.get(`/payments`, { params: { ...rest } });
  
  // Fake pagination processing since backend returns an array
  let data = response.data || [];
  let total = data.length;
  if (pagination) {
    const start = (pagination.current - 1) * pagination.pageSize;
    data = data.slice(start, start + pagination.pageSize);
  }
  
  return {
    data,
    total,
  };
};

export const uploadPaymentReceipt = async (id: number, receiptUrl: string) => {
  const response = await api.put(`/payments/${id}/receipt`, { receiptId: receiptUrl });
  return response.data;
};
